import { getImageUrl } from "../../../../../helpers/PB";

const ProductsConfig = {
  collection: "products",
  fields: [
    "id",
    "modified_on",
    "created_on",
    "name",
    "brand_family.brand.brand",
    "brand_family.family",
    "model",
    "sku",
    "product_type.name",
    "product_type.locale.label",
    "locale.code",
    "locale.tec_kwh_week",
    "locale.tec_kwh_year",
    "locale.print_speed_ipm",
    "locale.print_speed_mppm",
    "locale.max_power",
    "locale.power_requirements",
    "locale.product_image"
  ],

  adapter: class Product {
    constructor(product) {
      Object.assign(this, product);
      this.date_updated = this.modified_on || this.created_on;
      this.locale = (this.locale || []).reduce((acc, locale) => {
        acc[locale.code] = {
          ...locale,
          product_image: getImageUrl(locale.product_image),
          tec_kwh_week: Number.parseFloat(locale.tec_kwh_week) || 0,
          tec_kwh_year: Number.parseFloat(locale.tec_kwh_year) || 0,
          print_speed_ipm: Number.parseFloat(locale.print_speed_ipm) || 0,
          print_speed_mppm: Number.parseFloat(locale.print_speed_mppm) || 0,
          missing_energy_data:
            locale.tec_kwh_week === null ||
            locale.tec_kwh_week === undefined ||
            // only weekly is used for calculations
            // locale.tec_kwh_year === null ||
            // locale.tec_kwh_year === undefined ||
            locale.print_speed_ipm === null ||
            locale.print_speed_ipm === undefined ||
            locale.print_speed_mppm === null ||
            locale.print_speed_mppm === undefined
        };
        return acc;
      }, {});
    }
  }
};

export default ProductsConfig;
